/* eslint-disable no-unused-vars */
import { LeadServiceJava } from "../../../service/lead-service-java-api";
import { PdiCmsService } from "../../../service/pdi-cms-service";
import { VasBffService } from "../../../service/vas-bff-service";
import { parsePdiCmsData } from "../../../utils/helpers/pdi-cms-data-parser";
import { getParsedIntentData } from "../../shared/pre-delivery-inspection-confirmation-status/selector";
import { setData } from "../pre-delivery-inspection/actions";

const getPdiCmsData = () => {
    return new Promise((resolve, reject) => {
        VasBffService.getPdiData()
            .then(response => {
                resolve(response.data.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getPdiData = () => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.getPdiPriceDetails()
            .then(response => {
                resolve(response.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getPdiIntentData = () => dispatch => {
    return new Promise(async (resolve, reject) => {
        try {
            const [pdiData, vasPdiData] = await Promise.all([
                getPdiData(),
                getPdiCmsData()
            ]);

            const { cmsData: data } = vasPdiData;
            const { cmsData: cmsDetails } = parsePdiCmsData({
                data: {
                    ...data?.data,
                    carTypeList: getParsedIntentData(pdiData, data?.data || {})
                }
            });
            dispatch(setData({ cmsDetails }));
            resolve(cmsDetails);
        } catch (e) {
            reject(e);
        }
    });
};

export { getPdiIntentData };
